var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-box" }, [
    _c(
      "form",
      {
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.search($event)
          }
        }
      },
      [
        _c("input", {
          directives: [
            { name: "model", rawName: "v-model", value: _vm.q, expression: "q" }
          ],
          attrs: { type: "text", placeholder: "Type to search" },
          domProps: { value: _vm.q },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.q = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("button", [_vm._v("Search")])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }